/**
 * Navigation primitives with view transitions enabled by default.
 *
 * Re-exports of react-router-dom's `Link` and `NavLink` with the
 * `viewTransition` flag pre-set, so every internal navigation triggers
 * `document.startViewTransition()` and cross-fades between routes. Browsers
 * without the View Transitions API (Firefox at the time of writing, Safari
 * ≤17) fall back to standard navigation — no error, no flash.
 *
 * Always import `Link` and `NavLink` from `@sica/ui` (or this module
 * directly), never from `react-router-dom`. Bypassing the wrapper breaks the
 * cross-fade and the perceived continuity between SICA surfaces.
 *
 * The CSS that defines `::view-transition-old(root)` / `::view-transition-new(root)`
 * lives in `@sica/ui/index.css`. Reduced motion disables both animations and
 * smooth scroll.
 */
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  type LinkProps,
  type NavLinkProps,
} from 'react-router-dom';

export function Link(props: LinkProps) {
  return <RouterLink viewTransition {...props} />;
}

export function NavLink(props: NavLinkProps) {
  return <RouterNavLink viewTransition {...props} />;
}
